import { render, staticRenderFns } from "./TagHeader.vue?vue&type=template&id=b4e4e8ec&scoped=true"
import script from "./TagHeader.vue?vue&type=script&lang=js"
export * from "./TagHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e4e8ec",
  null
  
)

export default component.exports